
class Github {
    base_url: string = 'https://github.com'

    tree(repository: string, ref: string): string {
        return this.base_url + '/' + repository + '/tree/' + ref;
    }

    commit(repository: string, ref: string): string {
        return this.base_url + '/' + repository + '/commit/' + ref;
    }

    compare(repository: string, base: string, head: string) {
        return this.base_url + '/' + repository + '/compare/' + base + '...' + head; 
    }

}

export { Github }